module.exports = __webpack_public_path__ + "img/station1.341f1c89.png";